import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import './AdBanner.css';

const AdBanner = ({ slot, format = 'auto', style = {} }) => {
  const { isPremium } = useAuth();

  useEffect(() => {
    // Initialize AdSense ads
    try {
      if (window.adsbygoogle && !isPremium()) {
        window.adsbygoogle.push({});
      }
    } catch (error) {
      console.log('AdSense error:', error);
    }
  }, [isPremium]);

  // Don't show ads to premium users
  if (isPremium()) {
    return null;
  }

  // For development, show a placeholder
  if (process.env.NODE_ENV === 'development') {
    return (
      <div className="ad-container ad-placeholder" style={style}>
        <span>Ad Space</span>
        <small>Upgrade to Premium for an ad-free experience</small>
      </div>
    );
  }

  return (
    <div className="ad-container" style={style}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block', ...style }}
        data-ad-client="ca-pub-6168949306279584"
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"
      ></ins>
    </div>
  );
};

export default AdBanner;
